import React from 'react';
import {
    Button,
    Form,
    FormGroup,
    Col,
    Label,
    Input,
    ListGroup,
    ListGroupItem,
    ListGroupItemHeading,
    ListGroupItemText
} from 'reactstrap';
import { setTitle } from './util';
import fetch from './fetch';
import mfgFetch from "./mfg-fetch";
import {LineChart, XAxis, YAxis, CartesianGrid, Line, Tooltip, ResponsiveContainer, Brush, Legend} from 'recharts';


class AdminLogging extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            logs: [],
            manufacturer: "-1",
        };
    }

    componentWillMount() {
    }


    componentDidMount() {
        setTitle('Activity Logs');
        this.grabLogs();
    }

    grabLogs() {
        mfgFetch('/api/v1/mfg/logs', {
            method: 'GET'
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                let body = await resp.json();
                if (body) {
                    this.setState({
                        logs: body,
                    });
                }
            })
            .catch((err) => {
                console.error("Could not get activity logs", err);
            });

    }

    updateManufacturerValue(e) {
        this.setState({
            manufacturer: e.target.value
        });
    }


    render() {

        let logs = [];
        if (this.state.logs) {
            for (let log of this.state.logs) {
                if (log.activity_manufacturer !== this.state.manufacturer && this.state.manufacturer !== "-1") {
                    continue;
                }
                let date = new Date(log.activity_created);
                let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit' };

                logs.push(
                    <ListGroupItem className="activity-log-admin">
                        <ListGroupItemHeading>{date.toLocaleString("default", options)}</ListGroupItemHeading>
                        <span className="d-flex flex-row">
                            <span className="d-flex flex-column log-user">
                                <ListGroupItemText><b>User: {log.activity_username}</b></ListGroupItemText>
                                <ListGroupItemText><b>{ log.activity_manufacturer_text === "Admin" ? "Administrator" : "Manufacturer: " + log.activity_manufacturer_text}</b></ListGroupItemText>
                            </span>
                            <ListGroupItemText className="flex-fill align-self-center">{log.activity_message}</ListGroupItemText>
                        </span>
                    </ListGroupItem>
                );
            }
        }


        return (
            <div className="d-flex flex-row justify-content-center p-1">
                <span className="activity-log flex-fill">
                    <span className="d-flex flex-row justify-content-around">
                        <h2>Activity Log</h2>
                        <span>
                            <Label className="pr-1">Filter by Manufacturer:</Label>
                            <select name="manufacturer" value={this.state.manufacturer} onChange={e => this.updateManufacturerValue(e)} className="ml-1">
                                <option value="2">Brushlink</option>
                                <option value="1">Admin</option>
                                <option value="-1">All</option>
                            </select>
                        </span>
                    </span>
                    <ListGroup>
                        {logs}
                    </ListGroup>
                </span>
            </div>
        );
    }
}

export default AdminLogging;